import React from 'react';
import 'react-customize-token-input/dist/react-customize-token-input.css';
import { Editor, EditorTools } from "@progress/kendo-react-editor";
import { SpheraInput, SpheraDropdownEx, SpheraTooltip, SpheraModal } from "@sphera-cloud/component-ui-reactjs";
import { htmlDecode } from "../../services/Utils";

export function AddEditDefaultTextModal(props) {
    const { Bold, Italic, Underline, Strikethrough, Subscript, Superscript, AlignLeft, AlignCenter, AlignRight,
        AlignJustify, Indent, Outdent, OrderedList, UnorderedList, Undo, Redo, FontSize, FontName, FormatBlock,
        Link, Unlink } = EditorTools;

    const changeName = event => {
        let defaultText = props.selectedDefaultText;
        defaultText.defaultTextName = event.value;
        props.setselectedDefaultText(defaultText);
    }

    return (
        <div>
            {props.show && (
                <SpheraModal className="AddEditDefaultTextModal" title={props.localizations.AddEditDefaultText}
                    width={1000} height={910} onClose={props.toggleModal}
                    onCancel={props.toggleModal} cancelText={props.localizations.Cancel} actionText={props.localizations.Save}
                    onAction={props.save} >
                    <div className="container" style={{ width: "99%"}} >
                        <div className="row" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                            <div className="col-6 modalFieldDiv">
                                <SpheraTooltip position="top">
                                    <SpheraInput
                                        title={props.localizations.Name}
                                        label={props.localizations.Name}
                                        name="name"
                                        required
                                        type="text"
                                        valid={!props.validationError}
                                        placeholder={props.localizations.Name}
                                        value={htmlDecode(props.selectedDefaultText.defaultTextName)}
                                        onChange={changeName}
                                        maxLength={50}
                                        width={470}
                                    />
                                </SpheraTooltip>
                            </div>
                            <div className="col-6 modalFieldDiv">
                                <SpheraDropdownEx wrap filterable hierarchyIcon={false} onFilterChange={(e) => {
                                    let filteredData = props.localesDropdownData.filter(x => x.label.toLowerCase().includes(e.filter.value.toLowerCase()));
                                    props.setfilteredLocales(filteredData);
                                }} label={props.localizations.Language} onChange={props.handleLocalesDropdownChange} options={props.filteredLocales} width="100%" value={props.localeSelected} />
                            </div>
                            <div className={props.validationError ? "searchNotValidText" : "searchNotValidTextHidden"} >{props.validationErrorMessage}</div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <label className="sphera-label-text" style={{ marginTop: "10px" }}>{props.localizations.DefaultText}</label>
                                <Editor
                                    tools={[
                                        [Bold, Italic, Underline, Strikethrough],
                                        [Subscript, Superscript],
                                        [AlignLeft, AlignCenter, AlignRight, AlignJustify],
                                        [Indent, Outdent],
                                        [OrderedList, UnorderedList],
                                        FontSize, FontName, FormatBlock,
                                        [Undo, Redo],
                                        [Link, Unlink]
                                    ]}
                                    contentStyle={{ height: 200 }}
                                    value={props.CurrentDefaultTextValue} onChange={props.handleDefaultTextValueChange}
                                />
                            </div>
                        </div>
                    </div>
                </SpheraModal>
            )}
        </div>
    );
}